interface PaginatedApiResponse<T> {
  items?: T[];
  pages?: number;
}

export class PaginatedFetchError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
    this.name = 'PaginatedFetchError';
  }
}

/**
 * Загружает все страницы пагинированного API-эндпоинта (page/size, max size=200).
 */
export async function fetchAllPaginatedItems<T>(
  baseUrl: string,
  headers: HeadersInit,
  pageSize = 200,
): Promise<T[]> {
  const allItems: T[] = [];
  let page = 1;
  let totalPages = 1;

  while (page <= totalPages) {
    const separator = baseUrl.includes('?') ? '&' : '?';
    const response = await fetch(
      `${baseUrl}${separator}page=${page}&size=${pageSize}`,
      { headers },
    );

    if (!response.ok) {
      throw new PaginatedFetchError(`HTTP ${response.status}`, response.status);
    }

    const data: T[] | PaginatedApiResponse<T> = await response.json();

    if (Array.isArray(data)) {
      return data;
    }

    allItems.push(...(data.items ?? []));
    totalPages = data.pages ?? 1;
    page += 1;
  }

  return allItems;
}
